import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  firstName: '',
  lastName: '',
  errors: {},
  isDisabled: false,
}

const editNameSlice = createSlice({
  name: 'editNameForm',
  initialState,
  reducers: {
    setFirstName: (state, action) => {
      state.firstName = action.payload
    },
    setLastName: (state, action) => {
      state.lastName = action.payload
    },
    setfullName: (state, action) => {
      state.firstName = action.payload.firstName
      state.lastName = action.payload.lastName
    },
    resetNameForm: () => initialState,
    setErrors: (state, action) => {
      state.errors = { ...state.errors, ...action.payload }
    },
    resetErrors: (state) => {
      state.errors = {}
    },
    setIsDisabled: (state, action) => {
      state.isDisabled = action.payload
    }
  }
})

export const {
  setFirstName, setLastName, setfullName, resetNameForm, setErrors, resetErrors, setIsDisabled
} = editNameSlice.actions

export default editNameSlice.reducer
